import React, { useState, useEffect, useContext } from 'react'
import Banner from '../component/Common/Banner'
import { withRouter } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { compose } from 'redux'
import { connect } from "react-redux";
import * as actions from "../actions/result";
import { Link } from 'react-router-dom';
import { RWebShare } from "react-web-share";
import { IoShareSocialOutline, IoChevronBackOutline, IoChevronForwardOutline } from 'react-icons/io5';

const Results = (props) => {
    const { t, i18n } = useTranslation();
    const [page, setPage] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState(12)

    useEffect(() => {
        props.fetchPagination(1, rowsPerPage)
    }, []);

    useEffect(() => {
    
    }, [props.results]);


    const handleChangePage = async (newPage) => {
        await setPage(newPage);
        props.fetchPagination(newPage + 1, rowsPerPage)
    };
    const handleSearch = async (searchText) => {
        await setPage(0);
        props.fetchPagination(1, rowsPerPage, searchText, searchText)
    };

    const handleFilterChange = async (title, description) => {
        await setPage(0);
        props.fetchPagination(1, rowsPerPage, title, description)
    };

    return (
        <>

            <Banner title={t('beforenafter')} />
            <div className='container mb-5 mt-n4'>
                <div className="row">
                    {props.results?.map((data, index) => (
                        <div className="col-lg-6 col-12 mb-1" key={index}>
                            <div className="product_wrappers_one">
                                <div className="thumb">

                                    <Link to={{
                                        pathname: `/result-details/${data?._id?.replaceAll(' ', '-').toLowerCase()}`, state: {
                                            service: data
                                        }
                                    }}
                                        className={"image"}>
                                        <img src={process.env.REACT_APP_IMG_URL + data.icon} />
                                        <img className="hover-image" src={process.env.REACT_APP_IMG_URL + data.icon}
                                        />
                                    </Link>

                                </div>

                                <div className="content">
                                    {/* <small className='text-warn font-weight-light'>{data.categoryId.title[i18n.language]}</small> */}
                                    <h5 className="title">
                                        <Link to={{
                                             pathname: `/result-details/${(data.title.en).replaceAll(' ', '-').toLowerCase()}`, state: {
                                                service: data
                                            }
                                        }} >{data.title[i18n.language]}</Link>
                                    </h5>
                                    <small className=' mb-2'>{data.description[i18n.language]?.replace(/<[^>]+>|\n|&nbsp;|&amp;/g, '').slice(0, 60) + '...'}</small>

                                    <small className='mb-2'>{t('procedures')} : {data.services?.map((el, index) => (<span className='text-warn'>{index===0?'': ', '}{el.title[i18n.language]}</span>))}</small>
                                    <Link to={{
                                             pathname: `/result-details/${(data.title.en).replaceAll(' ', '-').toLowerCase()}`, state: {
                                                service: data
                                            }
                                        }} > <button className='btn cartbtn btn-sm btn-block mb-2'>{t('viewdetails')}</button>
                                    </Link>
                                    <div className='d-flex mt-2'>
                                        <div className='float-left'>
                                        <img src={process.env.REACT_APP_IMG_URL + data?.doctor?.image} style={{borderRadius:50, height:30, width:30, objectFit: 'cover',objectPosition: 'top'}}/>
                                
                                        </div>
                                        <div className='float-left ml-2'>
                                       
                                        <div className='small font-weight-bold mb-n2'>{data?.doctor?.name?.[i18n.language]}</div>
                                        <small >{data?.doctor?.education?.[i18n.language]}</small>
                                        </div>
                                    </div>
                                    {/* <div className='row'>
                                        <div className='col-xl-12 text-center'>
                                        <button type="button" className="btn cartbtn btn-sm" >{t('bookappt')}</button>
                
                                        <RWebShare
                                                data={{
                                                    text: data.description[i18n.language].slice(0, 55) + '...',
                                                    url: "http://localhost:3000/treatments/" + data.id,
                                                    title: data.title[i18n.language],
                                                }}
                                                onClick={() => console.log("shared successfully!")}
                                            >
                                                <a className="action quickview ml-2 float-right" ><IoShareSocialOutline /></a>
                                            </RWebShare>
                                    
                                        </div>
                                    </div> */}

                                </div>

                            </div>
                        </div>
                    ))}
                    {props?.meta?.totalPages > 1 && <div className="col-lg-12 col-12 mb-1">
                        <ul className="pagination float-right">
                          {page>0 && <li className="page-item"><a className="page-link bg-white" onClick={() => handleChangePage(page - 1)}><IoChevronBackOutline /> {t('previous')}</a></li>}
                            {Array(props?.meta?.totalPages).fill().map((e, i) => (
                                <li className={`page-item ${page === i  ? "active" : ""}`}><a className="page-link" onClick={() => handleChangePage(i)}>{i + 1}</a></li>
                            ))}
                          {page+1!==props?.meta?.totalPages && <li className="page-item"><a className="page-link bg-white" disabled onClick={() => handleChangePage(page + 1)}>{t('nextt')} <IoChevronForwardOutline /></a></li>}
                        </ul>
                    </div>}
                </div>

            </div>
        </>
    )
}


const mapStateToProps = state => ({
    results: state?.result?.results,
    meta: state?.result?.metaResult,

})

const mapActionToProps = {

    fetchDepartments: actions.fetchAll,
    fetchPagination: actions.Pagination,
}


export default compose(
    withRouter,
    connect(mapStateToProps, mapActionToProps)
)(Results);